// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assist-data-wrapper-container {
  height: 100%;
  padding: 8px;
  width: 100%;
}
.assist-data-wrapper-container .assist-block-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
  border-radius: 4px;
  position: relative;
}
.assist-data-wrapper-container .assist-block-content:hover .scroll-to-bottom-wrappers {
  display: flex;
}
.assist-data-wrapper-container .assist-block-content .scroll-to-bottom-wrappers {
  z-index: 3;
  position: absolute;
  right: 10px;
  display: none;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid var(--Primary-200, #B2CCFF);
  background: var(--Gray-600, #475467);
  box-shadow: 0 4px 8px -2px rgba(16, 24, 40, 0.1019607843), 0 2px 4px -2px rgba(16, 24, 40, 0.0588235294);
  transition: all 0.3s ease-in !important;
  padding: 0;
  top: 60px;
}
.assist-data-wrapper-container .assist-block-content .scroll-to-bottom-wrappers:hover {
  transform: scale(2) !important;
}
.assist-data-wrapper-container .assist-block-content .scroll-to-bottom-wrappers.down-arrow {
  bottom: 18px;
  top: auto;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content {
  display: flex;
  align-items: center;
  padding: 8px;
  min-height: 36px;
  gap: 10px;
  border-bottom: 1px solid var(--AA-gloabl-border);
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .left-title-info {
  width: 100%;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .left-title-info .text-dropdown-info {
  display: flex;
  align-items: center;
  gap: 6px;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .left-title-info .text-dropdown-info h1 {
  color: var(--AA-gloabl-text-color);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .left-title-info .text-dropdown-info .interrupt-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .left-title-info .text-dropdown-info .interrupt-wrapper .dialogs-number {
  border-radius: 4px;
  background: var(--AA-global-theme-bg);
  flex-shrink: 0;
  padding: 0px 4px;
  color: var(--AA-global-white-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  min-width: 16px;
  text-align: center;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .left-title-info .text-dropdown-info .interrupt-wrapper .aa-dropdown .aa-dropdown-toggle {
  padding: 0;
  border: 0;
  background: transparent;
  width: 16px;
  height: 16px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .left-title-info .bottom-titles {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 2px;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .left-title-info .bottom-titles p {
  color: var(--AA-gloabl-text-desc-color);
  max-width: 100%;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .left-title-info .bottom-titles .entity-name-cstm {
  display: flex;
  align-items: center;
  padding-left: 6px;
  border-left: 1px solid var(--AA-gloabl-border);
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 2px;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .actions-assist-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: 0.2s all ease;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .actions-assist-header .solid-action {
  border-radius: 3px;
  border: 0px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
  display: flex;
  width: 25px;
  height: 25px;
  padding: 0;
  justify-content: center;
  align-items: center;
  gap: 6px;
  color: var(--AA-gloabl-text-color);
  font-size: 16px;
  cursor: pointer;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .actions-assist-header .solid-action svg {
  width: 14px;
  height: 14px;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .actions-assist-header .solid-action svg path {
  fill: var(--AA-gloabl-text-color);
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .actions-assist-header .solid-action:disabled {
  opacity: 0.3;
  pointer-events: none;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .actions-assist-header .solid-action:hover {
  border: 1px solid var(--AA-global-theme-bg);
  color: var(--AA-global-theme-text-color);
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .actions-assist-header .solid-action.stop-assist {
  border: 0px solid var(--error-200, #FECDCA);
  background: var(--AA-global-white-bg);
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .actions-assist-header .solid-action.stop-assist:hover {
  border: 1px solid var(--error-300, #FDA29B);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.1);
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .actions-assist-header .solid-action span {
  width: 12px;
  height: 12px;
  background: #D92D20;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .actions-assist-header .solid-action sup.summary-indicator {
  position: absolute;
  background: var(--Error-500, #F04438);
  width: 2px;
  height: 2px;
  border-radius: 100%;
  right: 3px;
  top: 3px;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .actions-assist-header .sentiment-sec-wrapper .sentiment-btn {
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 400;
  line-height: 18px;
  border: 0;
  border-radius: 16px;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .actions-assist-header .sentiment-sec-wrapper .sentiment-btn.negative-title {
  color: var(--Destructive-700, #B91C1C);
  background: var(--Destructive-50, #FEF2F2);
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .actions-assist-header .sentiment-sec-wrapper .sentiment-btn.positive-title {
  color: #027a48;
  background: #ecfdf3;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .actions-assist-header .sentiment-sec-wrapper .sentiment-btn.neutral-title {
  background: #c9c1c1;
  color: #667085;
}
.assist-data-wrapper-container .assist-block-content .assist-header-content .actions-assist-header .sentiment-sec-wrapper .sentiment-chart-drp {
  width: 100%;
  left: 0;
  top: 42px;
  padding: 10px;
  border-radius: 8px;
  min-width: 200px;
  background: var(--AA-gloabl-bg-secondary);
  box-shadow: 0 2px 4px -2px rgba(16, 24, 40, 0.0588235294), 0 4px 8px -2px rgba(16, 24, 40, 0.1019607843);
  z-index: 6;
  max-width: 95%;
  right: 0;
  margin: 0 auto;
}
.assist-data-wrapper-container .assist-block-content .scroll-data-assist {
  flex: 1 1 auto;
  height: 100%;
  overflow: auto;
}
.assist-data-wrapper-container .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper {
  padding: 12px;
  border-radius: 8px;
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-gloabl-bg-secondary);
  margin: 8px;
}
.assist-data-wrapper-container .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper .heading-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 10px;
}
.assist-data-wrapper-container .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper .heading-text svg {
  flex-shrink: 0;
}
.assist-data-wrapper-container .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper .heading-text svg path {
  fill: var(--AA-gloabl-text-color);
}
.assist-data-wrapper-container .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper li {
  color: var(--AA-gloabl-text-color);
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  list-style-type: none;
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
}
.assist-data-wrapper-container .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper li span {
  width: 100%;
}
.assist-data-wrapper-container .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper li .copy-btn {
  padding: 0;
  width: 25px;
  height: 25px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border: 0;
  background: transparent;
  display: flex;
  cursor: pointer;
  border-radius: 4px;
  transition: 0.2s all ease;
}
.assist-data-wrapper-container .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper li .copy-btn svg path {
  stroke: var(--AA-gloabl-text-color);
}
.assist-data-wrapper-container .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper li .copy-btn:hover {
  background: var(--AA-global-white-bg);
}

.empty-listing-triggers {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  padding: 0 16px;
}

.app-dialog-assit-wrapper {
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.aa-dialog-ended-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  padding: 12px 0;
  width: 100%;
}
.aa-dialog-ended-wrapper .line_bar {
  width: 100%;
  border-top: 1px solid var(--AA-global-theme-bg);
}
.aa-dialog-ended-wrapper .middle-info {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 3px;
}
.aa-dialog-ended-wrapper .middle-info p {
  font-size: 10px;
  letter-spacing: 0.7px;
}
.aa-dialog-ended-wrapper .middle-info button {
  font-size: 10px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.7px;
  max-width: 110px;
}

.custom-tab-data-wrapper-container {
  padding: 8px;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content {
  border: 1px solid var(--AA-gloabl-border);
  border-radius: 4px;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--AA-global-white-bg);
  border-radius: 4px;
  position: relative;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content:hover .scroll-to-bottom-wrappers {
  display: flex;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .scroll-to-bottom-wrappers {
  z-index: 3;
  position: absolute;
  right: 10px;
  display: none;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid var(--Primary-200, #B2CCFF);
  background: var(--Gray-600, #475467);
  box-shadow: 0 4px 8px -2px rgba(16, 24, 40, 0.1019607843), 0 2px 4px -2px rgba(16, 24, 40, 0.0588235294);
  transition: all 0.3s ease-in !important;
  padding: 0;
  top: 60px;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .scroll-to-bottom-wrappers:hover {
  transform: scale(2) !important;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .scroll-to-bottom-wrappers.down-arrow {
  bottom: 18px;
  top: auto;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content {
  display: flex;
  align-items: center;
  padding: 8px;
  min-height: 36px;
  gap: 10px;
  border-bottom: 1px solid var(--AA-gloabl-border);
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .left-title-info {
  width: 100%;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .left-title-info .text-dropdown-info {
  display: flex;
  align-items: center;
  gap: 6px;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .left-title-info .text-dropdown-info h1 {
  color: var(--AA-gloabl-text-color);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .left-title-info .text-dropdown-info .interrupt-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .left-title-info .text-dropdown-info .interrupt-wrapper .dialogs-number {
  border-radius: 4px;
  background: var(--AA-global-theme-bg);
  flex-shrink: 0;
  padding: 0px 4px;
  color: var(--AA-global-white-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  min-width: 16px;
  text-align: center;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .left-title-info .text-dropdown-info .interrupt-wrapper .aa-dropdown .aa-dropdown-toggle {
  padding: 0;
  border: 0;
  background: transparent;
  width: 16px;
  height: 16px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .left-title-info .bottom-titles {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 2px;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .left-title-info .bottom-titles p {
  color: var(--AA-gloabl-text-desc-color);
  max-width: 100%;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .left-title-info .bottom-titles .entity-name-cstm {
  display: flex;
  align-items: center;
  padding-left: 6px;
  border-left: 1px solid var(--AA-gloabl-border);
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 2px;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: 0.2s all ease;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .solid-action {
  border-radius: 3px;
  border: 0px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
  display: flex;
  width: 25px;
  height: 25px;
  padding: 0;
  justify-content: center;
  align-items: center;
  gap: 6px;
  color: var(--AA-gloabl-text-color);
  font-size: 16px;
  cursor: pointer;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .solid-action svg {
  width: 14px;
  height: 14px;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .solid-action svg path {
  fill: var(--AA-gloabl-text-color);
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .solid-action:disabled {
  opacity: 0.3;
  pointer-events: none;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .solid-action:hover {
  border: 1px solid var(--AA-global-theme-bg);
  color: var(--AA-global-theme-text-color);
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .solid-action.stop-assist {
  border: 0px solid var(--error-200, #FECDCA);
  background: var(--AA-global-white-bg);
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .solid-action.stop-assist:hover {
  border: 1px solid var(--error-300, #FDA29B);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.1);
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .solid-action span {
  width: 12px;
  height: 12px;
  background: #D92D20;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .solid-action sup.summary-indicator {
  position: absolute;
  background: var(--Error-500, #F04438);
  width: 2px;
  height: 2px;
  border-radius: 100%;
  right: 3px;
  top: 3px;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .pause-auto-send-btn {
  background: transparent;
  width: 25px;
  height: 25px;
  padding: 0;
  gap: 6px;
  cursor: pointer;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .pause-auto-send-btn svg {
  width: 14px;
  height: 14px;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .pause-auto-send-btn svg path {
  fill: var(--AA-global-theme-bg);
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .pause-auto-send-btn.paused-auto-send-btn svg path {
  fill: var(--AA-global-white-bg);
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .sentiment-sec-wrapper .sentiment-btn {
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 400;
  line-height: 18px;
  border: 0;
  border-radius: 16px;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .sentiment-sec-wrapper .sentiment-btn.negative-title {
  color: var(--Destructive-700, #B91C1C);
  background: var(--Destructive-50, #FEF2F2);
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .sentiment-sec-wrapper .sentiment-btn.positive-title {
  color: #027a48;
  background: #ecfdf3;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .sentiment-sec-wrapper .sentiment-btn.neutral-title {
  background: #c9c1c1;
  color: #667085;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .assist-header-content .actions-assist-header .sentiment-sec-wrapper .sentiment-chart-drp {
  width: 100%;
  left: 0;
  top: 42px;
  padding: 10px;
  border-radius: 8px;
  min-width: 200px;
  background: var(--AA-gloabl-bg-secondary);
  box-shadow: 0 2px 4px -2px rgba(16, 24, 40, 0.0588235294), 0 4px 8px -2px rgba(16, 24, 40, 0.1019607843);
  z-index: 6;
  max-width: 95%;
  right: 0;
  margin: 0 auto;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .scroll-data-assist {
  flex: 1 1 auto;
  height: 100%;
  overflow: auto;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper {
  padding: 12px;
  border-radius: 8px;
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-gloabl-bg-secondary);
  margin: 8px;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper .heading-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 10px;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper .heading-text svg {
  flex-shrink: 0;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper .heading-text svg path {
  fill: var(--AA-gloabl-text-color);
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper li {
  color: var(--AA-gloabl-text-color);
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  list-style-type: none;
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper li span {
  width: 100%;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper li .copy-btn {
  padding: 0;
  width: 25px;
  height: 25px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border: 0;
  background: transparent;
  display: flex;
  cursor: pointer;
  border-radius: 4px;
  transition: 0.2s all ease;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper li .copy-btn svg path {
  stroke: var(--AA-gloabl-text-color);
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .assist-block-content .scroll-data-assist .summery-conv-banner-wrapper li .copy-btn:hover {
  background: var(--AA-global-white-bg);
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .custom-tab-footer-section {
  padding: 0 10px 10px 10px;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .custom-tab-footer-section .custom-dialog-workflows-header .show-dialog-task-btn {
  cursor: pointer;
  background: transparent;
  color: var(--AA-global-theme-text-color);
  border: 0;
  padding: 0;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .custom-tab-footer-section .custom-dialog-workflows-header .line-divider {
  height: 1px;
  background: var(--AA-gloabl-border);
  width: 100%;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .custom-tab-footer-section .custom-tab-dialog-card {
  border-radius: 4px;
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
  padding: 6px 8px;
  cursor: pointer;
}
.custom-tab-data-wrapper-container .custom-tab-data-wrapper-container-content .custom-tab-footer-section .custom-tab-dialog-card svg path {
  stroke: var(--AA-gloabl-text-desc-color);
}

.ask-cust-node {
  border-radius: 0px 10px 10px 10px;
  background: var(--AA-gloabl-bg-secondary);
  padding: 4px 8px;
  margin-bottom: 6px;
}
.ask-cust-node .top-section {
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 28px;
}
.ask-cust-node .top-section svg path {
  fill: var(--AA-global-theme-text-color);
}
.ask-cust-node .top-section p {
  margin: 0;
}
.ask-cust-node .msg-node-cust {
  border-radius: 10px;
  padding: 10px;
  color: var(--AA-gloabl-text-color);
  position: relative;
  margin-top: 4px;
  transition: 0.2s all ease;
  z-index: 0;
}
.ask-cust-node .msg-node-cust::before {
  content: "";
  background: var(--AA-global-theme-bg);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  left: 0;
  top: 0;
  border-radius: 10px;
  opacity: 0.1;
}
.ask-cust-node .msg-node-cust:hover .send-copy-actions {
  display: flex;
}
.ask-cust-node .msg-node-cust p {
  margin: 0;
  padding-right: 28px;
}
.ask-cust-node .msg-node-cust .send-copy-actions {
  border-radius: 4px;
  background: var(--AA-global-white-bg);
  box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.1);
  position: absolute;
  display: none;
  padding: 4px;
  align-items: center;
  gap: 6px;
  right: 8px;
  top: 4px;
  z-index: 1;
}
.ask-cust-node .msg-node-cust .send-copy-actions svg path {
  stroke: var(--AA-gloabl-text-color);
}
.ask-cust-node .msg-node-cust .send-copy-actions .aa-solidbtn {
  padding: 2px 11px;
}
.ask-cust-node .msg-node-cust .sent-msg-text {
  position: absolute;
  top: 0;
  right: 4px;
  color: var(--AA-global-theme-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

@-webkit-keyframes slideInLeftAnim {
  0% {
    -webkit-transform: translateX(-10px);
    transform: translateX(-10px);
    visibility: visible;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
@keyframes slideInLeftAnim {
  0% {
    -webkit-transform: translateX(-10px);
    transform: translateX(-10px);
    visibility: visible;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
.entity-mesage-data {
  padding: 8px;
  margin-bottom: 6px;
}
.entity-mesage-data.listView {
  padding: 0px !important;
}
.entity-mesage-data.error-no-reponse .input-block-entity textarea:focus + .border-outline, .entity-mesage-data.error-no-reponse .input-block-entity input:focus + .border-outline {
  border: 1px solid var(--destructive-300, #FCA5A5);
  box-shadow: 0px 0px 0px 4px #FEE4E2, 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
.entity-mesage-data.error-no-reponse .input-block-entity textarea + .border-outline, .entity-mesage-data.error-no-reponse .input-block-entity input + .border-outline {
  border: 1px solid var(--destructive-300, #FCA5A5);
}
.entity-mesage-data.error-no-reponse .info-entity-text {
  opacity: 1;
  color: var(--destructive-500-main, #EF4444);
}
.entity-mesage-data .input-block-entity {
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0px 12px;
  z-index: 2;
  min-height: 40px;
}
.entity-mesage-data .input-block-entity p {
  color: var(--AA-gloabl-text-desc-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin: 0;
  flex-shrink: 0;
  position: relative;
  z-index: 2;
  max-width: 85%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.entity-mesage-data .input-block-entity textarea[readonly], .entity-mesage-data .input-block-entity input[readonly] {
  opacity: 0.7;
}
.entity-mesage-data .input-block-entity textarea, .entity-mesage-data .input-block-entity input {
  width: 100%;
  border: 0;
  outline: 0;
  position: relative;
  z-index: 2;
  padding: 0;
  color: var(--AA-gloabl-text-desc-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  resize: none;
  background: transparent;
  overflow: auto;
}
.entity-mesage-data .input-block-entity textarea:focus + .border-outline, .entity-mesage-data .input-block-entity input:focus + .border-outline {
  border-radius: 8px;
  border: 1px solid var(--AA-global-theme-bg);
  box-shadow: 0px 0px 0px 4px #E1E1FE;
}
.entity-mesage-data .input-block-entity textarea + .border-outline, .entity-mesage-data .input-block-entity input + .border-outline {
  position: absolute;
  border-radius: 8px;
  border: 1px solid var(--AA-global-theme-bg);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.entity-mesage-data .input-block-entity textarea.disable-input, .entity-mesage-data .input-block-entity input.disable-input {
  opacity: 0.7;
}
.entity-mesage-data .input-block-entity textarea.attachment-input, .entity-mesage-data .input-block-entity input.attachment-input {
  position: absolute;
  left: 0;
  opacity: 0;
  font-size: 0px;
  cursor: pointer;
}
.entity-mesage-data .input-block-entity textarea.attachment-input.uploaded-img-attach, .entity-mesage-data .input-block-entity input.attachment-input.uploaded-img-attach {
  visibility: hidden;
  display: none;
}
.entity-mesage-data .input-block-entity svg {
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  cursor: pointer;
}
.entity-mesage-data .input-block-entity .attach-input {
  display: flex;
  align-items: center;
  gap: 5px;
  overflow: hidden;
  width: 100%;
}
.entity-mesage-data .input-block-entity .attach-input svg path {
  stroke: var(--AA-global-theme-bg);
}
.entity-mesage-data .input-block-entity .attachment-name {
  color: var(--AA-gloabl-text-desc-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  width: 100%;
}
.entity-mesage-data .input-block-entity .attachment-name.choose-file {
  color: var(--AA-global-theme-text-color);
}
.entity-mesage-data .input-block-entity .actions-inputs {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 2;
  gap: 4px;
  flex-shrink: 0;
  -webkit-animation-name: slideInLeftAnim;
  animation-name: slideInLeftAnim;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.entity-mesage-data .input-block-entity .actions-inputs .remove-input, .entity-mesage-data .input-block-entity .actions-inputs .success-check-input, .entity-mesage-data .input-block-entity .actions-inputs .check-input {
  width: 24px;
  height: 24px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0;
  font-size: 20px;
  color: var(--AA-gloabl-text-desc-color);
}
.entity-mesage-data .input-block-entity .actions-inputs .check-input {
  font-size: 12px;
  color: var(--AA-global-theme-text-color);
}
.entity-mesage-data .input-block-entity .actions-inputs .success-check-input {
  color: #12B76A;
}
.entity-mesage-data .input-block-entity .actions-inputs .wrong-res-info {
  display: flex;
  padding: 0px 10px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 24px;
  border: 1px solid var(--destructive-600, #DC2626);
  background: var(--destructive-50, #FEF2F2);
  color: var(--destructive-600, #DC2626);
  font-size: 12px;
  font-weight: 500;
  min-height: 22px;
}
.entity-mesage-data .input-block-entity .actions-inputs .wrong-res-info i {
  font-size: 16px;
}
.entity-mesage-data .input-block-entity .actions-inputs .override-btn {
  background: transparent;
  padding: 0;
  border: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
  color: var(--AA-global-theme-text-color);
}
.entity-mesage-data .info-entity-text {
  color: var(--AA-gloabl-text-desc-color);
  opacity: 0.7;
  font-size: 10px;
  font-weight: 500;
  line-height: normal;
  margin: 3px 0 0 0;
}

.expand-btn {
  background-color: transparent;
  border: none;
}

.reduce-btn {
  background-color: transparent;
  border: none;
}

.form-feedback-info {
  background: var(--AA-gloabl-bg-secondary);
  padding: 8px;
}
.form-feedback-info .dialog-ended-and-feedback {
  display: flex;
  align-items: center;
  gap: 10px;
}
.form-feedback-info .dialog-ended-and-feedback .line-border-content-info {
  width: 100%;
  top: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
.form-feedback-info .dialog-ended-and-feedback .line-border-content-info .line-border {
  background: var(--AA-global-theme-text-color);
  width: 100%;
  height: 1px;
}
.form-feedback-info .dialog-ended-and-feedback .line-border-content-info .date-time-text {
  flex-shrink: 0;
  border-radius: 16px;
  background: var(--AA-gloabl-bg-secondary);
  padding: 2px 8px;
  color: var(--AA-global-theme-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}
.form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info {
  display: flex;
  align-items: center;
  gap: 6px;
}
.form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
}
.form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info .icon_block {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
}
.form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info h1 {
  color: var(--AA-gloabl-text-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  margin: 0;
}
.form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info .feedback-btn-thumb {
  border-radius: 4px;
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
  display: flex;
  width: 20px;
  height: 20px;
  padding: 0;
  justify-content: center;
  align-items: center;
  gap: 6px;
  color: var(--AA-gloabl-text-color);
  font-size: 12px;
  cursor: pointer;
  transition: 0.2s all ease;
}
.form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info .feedback-btn-thumb svg path {
  stroke: var(--AA-gloabl-text-color);
}
.form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info .feedback-btn-thumb:disabled {
  opacity: 0.3;
}
.form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info .feedback-btn-thumb.active-feedback-btn {
  background: var(--AA-global-theme-bg);
  color: var(--AA-global-white-color);
}
.form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info .feedback-btn-thumb.active-feedback-btn svg path {
  stroke: var(--AA-global-white-color);
}
.form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info .feedback-btn-thumb:hover {
  background: var(--AA-global-theme-bg);
  color: var(--AA-global-white-color);
}
.form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info .feedback-btn-thumb:hover svg path {
  stroke: var(--AA-global-white-color);
}
.form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info .feedback-btn-arrow {
  border: 0;
  padding: 0;
  background: transparent;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transform: rotate(0);
  opacity: 0.7;
}
.form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info .feedback-btn-arrow svg path {
  fill: var(--AA-gloabl-text-color);
}
.form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info .feedback-btn-arrow.active-feedback-btn-rotate {
  transform: rotate(180deg);
}
.form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .thankyou-text {
  flex-shrink: 0;
  color: var(--AA-global-theme-bg);
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  padding-right: 8px;
}
.form-feedback-info .dialog-ended-and-feedback .form-feedback-div {
  flex-shrink: 0;
}
.form-feedback-info .improve-feedback-block {
  padding: 12px;
  border-radius: 10px;
  position: relative;
  z-index: 0;
  margin-top: 4px;
}
.form-feedback-info .improve-feedback-block::before {
  content: "";
  background: var(--AA-global-theme-bg);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  left: 0;
  top: 0;
  border-radius: 10px;
  opacity: 0.2;
}
.form-feedback-info .improve-feedback-block .improve-options-text {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 12px;
}
.form-feedback-info .improve-feedback-block .improve-options-text .improve-lable-text {
  border-radius: 16px;
  background: var(--AA-gloabl-bg-secondary);
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  color: var(--AA-gloabl-text-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  border: 0;
  min-height: 22px;
  transition: 0.2s all ease;
}
.form-feedback-info .improve-feedback-block .improve-options-text .improve-lable-text:hover {
  background: var(--AA-global-theme-bg);
  color: var(--AA-global-white-color);
}
.form-feedback-info .improve-feedback-block .improve-options-text .improve-lable-text.active-improve-btn {
  background: var(--AA-global-theme-bg);
  color: var(--AA-global-white-color);
}
.form-feedback-info .improve-feedback-block .input-improve-text {
  display: flex;
  align-items: center;
}
.form-feedback-info .improve-feedback-block .input-improve-text textarea {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  resize: none;
}
.form-feedback-info .improve-feedback-block .submit-count-text {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
  justify-content: flex-end;
}
.form-feedback-info .improve-feedback-block .submit-count-text p {
  width: 100%;
  color: var(--AA-gloabl-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
}
.form-feedback-info .improve-feedback-block .send-btn-feedback {
  flex-shrink: 0;
  height: 25px;
  border-radius: 8px;
  border: 1px solid var(--AA-global-theme-bg);
  background: var(--AA-global-theme-bg);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--AA-global-white-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
}
.form-feedback-info .improve-feedback-block .send-btn-feedback:disabled {
  opacity: 0.3;
}`, "",{"version":3,"sources":["webpack://./src/components/common/templatemanager/tabs/assist/assist.scss"],"names":[],"mappings":"AACA;EACI,YAAA;EACA,YAAA;EACA,WAAA;AAAJ;AACI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yCAAA;EACA,qCAAA;EACA,kBAAA;EACA,kBAAA;AACR;AACY;EACI,aAAA;AAChB;AAEQ;EACI,UAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;EACA,oCAAA;EACA,wGAAA;EACA,uCAAA;EACA,UAAA;EACA,SAAA;AAAZ;AACY;EACI,8BAAA;AAChB;AACY;EACI,YAAA;EACA,SAAA;AAChB;AAEQ;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,gDAAA;AAAZ;AACY;EACI,WAAA;AAChB;AACgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AACpB;AAAoB;EACI,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAExB;AAAoB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAExB;AADwB;EACI,kBAAA;EACA,qCAAA;EACA,cAAA;EACA,gBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAG5B;AAA4B;EACI,UAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEhC;AAGgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AADpB;AAEoB;EACI,uCAAA;EACA,eAAA;AAAxB;AAEoB;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,8CAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAAxB;AAIY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;AAFhB;AAGgB;EACI,kBAAA;EACA,yCAAA;EACA,qCAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;EACA,eAAA;EACA,eAAA;AADpB;AAEoB;EACI,WAAA;EACA,YAAA;AAAxB;AACwB;EACI,iCAAA;AAC5B;AAEoB;EACI,YAAA;EACA,oBAAA;AAAxB;AAEoB;EACI,2CAAA;EACA,wCAAA;AAAxB;AAEoB;EACI,2CAAA;EACA,qCAAA;AAAxB;AACwB;EACI,2CAAA;EACA,yFAAA;AAC5B;AAEoB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAAxB;AAGwB;EACI,kBAAA;EACA,qCAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;AAD5B;AAMoB;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;AAJxB;AAKwB;EACI,sCAAA;EACA,0CAAA;AAH5B;AAKwB;EACI,cAAA;EACA,mBAAA;AAH5B;AAKwB;EACI,mBAAA;EACA,cAAA;AAH5B;AAMoB;EACI,WAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;EACA,wGAAA;EACA,UAAA;EACA,cAAA;EACA,QAAA;EACA,cAAA;AAJxB;AAUQ;EACI,cAAA;EACA,YAAA;EACA,cAAA;AARZ;AASY;EACI,aAAA;EACA,kBAAA;EACA,yCAAA;EACA,yCAAA;EACA,WAAA;AAPhB;AAQgB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AANpB;AAOoB;EACI,cAAA;AALxB;AAMwB;EACI,iCAAA;AAJ5B;AAQgB;EACI,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;AANpB;AAOoB;EACI,WAAA;AALxB;AAOoB;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AALxB;AAO4B;EACI,mCAAA;AALhC;AAQwB;EACI,qCAAA;AAN5B;;AAeA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;AAZJ;;AAeA;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAZJ;;AAeA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;AAZJ;AAaI;EACI,WAAA;EACA,+CAAA;AAXR;AAaI;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,QAAA;AAXR;AAYQ;EACI,eAAA;EACA,qBAAA;AAVZ;AAYQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AAVZ;;AAgBA;EACI,YAAA;AAbJ;AAcI;EACI,yCAAA;EACA,kBAAA;AAZR;AAaQ;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,kBAAA;EACA,kBAAA;AAXZ;AAagB;EACI,aAAA;AAXpB;AAcY;EACI,UAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;EACA,oCAAA;EACA,wGAAA;EACA,uCAAA;EACA,UAAA;EACA,SAAA;AAZhB;AAagB;EACI,8BAAA;AAXpB;AAagB;EACI,YAAA;EACA,SAAA;AAXpB;AAcY;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,gDAAA;AAZhB;AAagB;EACI,WAAA;AAXpB;AAaoB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAXxB;AAYwB;EACI,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAV5B;AAYwB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAV5B;AAW4B;EACI,kBAAA;EACA,qCAAA;EACA,cAAA;EACA,gBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAThC;AAYgC;EACI,UAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAVpC;AAeoB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAbxB;AAcwB;EACI,uCAAA;EACA,eAAA;AAZ5B;AAcwB;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,8CAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAZ5B;AAgBgB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;AAdpB;AAeoB;EACI,kBAAA;EACA,yCAAA;EACA,qCAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;EACA,eAAA;EACA,eAAA;AAbxB;AAcwB;EACI,WAAA;EACA,YAAA;AAZ5B;AAa4B;EACI,iCAAA;AAXhC;AAcwB;EACI,YAAA;EACA,oBAAA;AAZ5B;AAcwB;EACI,2CAAA;EACA,wCAAA;AAZ5B;AAcwB;EACI,2CAAA;EACA,qCAAA;AAZ5B;AAa4B;EACI,2CAAA;EACA,yFAAA;AAXhC;AAcwB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAZ5B;AAe4B;EACI,kBAAA;EACA,qCAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;AAbhC;AAiBoB;EACI,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;AAfxB;AAgBwB;EACI,WAAA;EACA,YAAA;AAd5B;AAe4B;EACI,+BAAA;AAbhC;AAkBgC;EACI,+BAAA;AAhBpC;AAsBwB;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;AApB5B;AAqB4B;EACI,sCAAA;EACA,0CAAA;AAnBhC;AAqB4B;EACI,cAAA;EACA,mBAAA;AAnBhC;AAqB4B;EACI,mBAAA;EACA,cAAA;AAnBhC;AAsBwB;EACI,WAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;EACA,wGAAA;EACA,UAAA;EACA,cAAA;EACA,QAAA;EACA,cAAA;AApB5B;AA0BY;EACI,cAAA;EACA,YAAA;EACA,cAAA;AAxBhB;AAyBgB;EACI,aAAA;EACA,kBAAA;EACA,yCAAA;EACA,yCAAA;EACA,WAAA;AAvBpB;AAwBoB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AAtBxB;AAuBwB;EACI,cAAA;AArB5B;AAsB4B;EACI,iCAAA;AApBhC;AAwBoB;EACI,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;AAtBxB;AAuBwB;EACI,WAAA;AArB5B;AAuBwB;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AArB5B;AAuBgC;EACI,mCAAA;AArBpC;AAwB4B;EACI,qCAAA;AAtBhC;AA6BQ;EACI,yBAAA;AA3BZ;AA6BgB;EACI,eAAA;EACA,uBAAA;EACA,wCAAA;EACA,SAAA;EACA,UAAA;AA3BpB;AA6BgB;EACI,WAAA;EACA,mCAAA;EACA,WAAA;AA3BpB;AA8BY;EACI,kBAAA;EACA,yCAAA;EACA,qCAAA;EACA,gBAAA;EACA,eAAA;AA5BhB;AA8BoB;EACI,wCAAA;AA5BxB;;AAoCA;EACI,iCAAA;EACA,yCAAA;EACA,gBAAA;EACA,kBAAA;AAjCJ;AAkCI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAhCR;AAkCY;EACI,uCAAA;AAhChB;AAmCQ;EACI,SAAA;AAjCZ;AAoCI;EACI,mBAAA;EACA,aAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,UAAA;AAlCR;AAmCQ;EACI,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,mBAAA;EACA,YAAA;AAjCZ;AAoCY;EACI,aAAA;AAlChB;AAqCQ;EACI,SAAA;EACA,mBAAA;AAnCZ;AAqCQ;EACI,kBAAA;EACA,qCAAA;EACA,2FAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AAnCZ;AAqCgB;EACI,mCAAA;AAnCpB;AAsCY;EACI,iBAAA;AApChB;AAuCQ;EACI,kBAAA;EACA,MAAA;EACA,UAAA;EACA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AArCZ;;AA4CA;EACI;IACI,oCAAA;IACA,4BAAA;IACA,mBAAA;EAzCN;EA4CE;IACI,gCAAA;IACA,wBAAA;EA1CN;AACF;AA6CA;EACI;IACI,oCAAA;IACA,4BAAA;IACA,mBAAA;EA3CN;EA8CE;IACI,gCAAA;IACA,wBAAA;EA5CN;AACF;AA+CA;EACI,YAAA;EACA,kBAAA;AA7CJ;AA8CI;EACI,uBAAA;AA5CR;AAkDoB;EACI,iDAAA;EACA,2EAAA;AAhDxB;AAmDgB;EACI,iDAAA;AAjDpB;AAqDQ;EACI,UAAA;EACA,2CAAA;AAnDZ;AAsDI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;AApDR;AAqDQ;EACI,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAnDZ;AAqDQ;EACI,YAAA;AAnDZ;AAqDQ;EACI,WAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EAEA,YAAA;EACA,uBAAA;EACA,cAAA;AApDZ;AAsDgB;EACI,kBAAA;EACA,2CAAA;EACA,mCAAA;AApDpB;AAuDY;EACI,kBAAA;EACA,kBAAA;EACA,2CAAA;EACA,kDAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;AArDhB;AAuDY;EACI,YAAA;AArDhB;AAuDY;EACI,kBAAA;EACA,OAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AArDhB;AAsDgB;EACI,kBAAA;EACA,aAAA;AApDpB;AAwDQ;EACI,cAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AAtDZ;AAwDQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;AAtDZ;AAwDgB;EACI,iCAAA;AAtDpB;AA0DQ;EACI,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAxDZ;AAyDY;EACI,wCAAA;AAvDhB;AA0DQ;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,cAAA;EACA,uCAAA;EACA,+BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AAxDZ;AAyDY;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,uCAAA;AAvDhB;AAyDY;EAEI,eAAA;EACA,wCAAA;AAxDhB;AA0DY;EAEI,cAAA;AAzDhB;AA2DY;EACI,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,iDAAA;EACA,0CAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAzDhB;AA0DgB;EACI,eAAA;AAxDpB;AA2DY;EACI,uBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,wCAAA;AAzDhB;AA6DI;EACI,uCAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AA3DR;;AA+DA;EACI,6BAAA;EACA,YAAA;AA5DJ;;AA+DA;EACI,6BAAA;EACA,YAAA;AA5DJ;;AA+DA;EACI,yCAAA;EACA,YAAA;AA5DJ;AA6DI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AA3DR;AA4DQ;EACI,WAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA1DZ;AA2DY;EACI,6CAAA;EACA,WAAA;EACA,WAAA;AAzDhB;AA2DY;EACI,cAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAzDhB;AA6DY;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AA3DhB;AA4DgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AA1DpB;AA2DoB;EACI,cAAA;EACA,WAAA;EACA,YAAA;AAzDxB;AA2DoB;EACI,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AAzDxB;AA2DoB;EACI,kBAAA;EACA,yCAAA;EACA,qCAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AAzDxB;AA2D4B;EACI,mCAAA;AAzDhC;AA4DwB;EACI,YAAA;AA1D5B;AA4DwB;EACI,qCAAA;EACA,mCAAA;AA1D5B;AA4DgC;EACI,oCAAA;AA1DpC;AA8DwB;EACI,qCAAA;EACA,mCAAA;AA5D5B;AA8DgC;EACI,oCAAA;AA5DpC;AAiEoB;EACI,SAAA;EACA,UAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;AA/DxB;AAiE4B;EACI,iCAAA;AA/DhC;AAkEwB;EACI,yBAAA;AAhE5B;AAoEgB;EACI,cAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;AAlEpB;AAsEQ;EACI,cAAA;AApEZ;AAyEI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AAvER;AAwEQ;EACI,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,mBAAA;EACA,YAAA;AAtEZ;AAwEQ;EACI,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAtEZ;AAuEY;EACI,mBAAA;EACA,yCAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;AArEhB;AAuEgB;EACI,qCAAA;EACA,mCAAA;AArEpB;AAuEgB;EACI,qCAAA;EACA,mCAAA;AArEpB;AAyEQ;EACI,aAAA;EACA,mBAAA;AAvEZ;AAwEY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAtEhB;AAyEQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;AAvEZ;AAwEY;EACI,WAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AAtEhB;AAyEQ;EACI,cAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;EACA,qCAAA;EACA,kDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAvEZ;AAwEY;EACI,YAAA;AAtEhB","sourcesContent":["\n.assist-data-wrapper-container{\n    height: 100%;\n    padding: 8px;\n    width: 100%;\n    .assist-block-content{\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        border: 1px solid var(--AA-gloabl-border);\n        background: var(--AA-global-white-bg);\n        border-radius: 4px;\n        position: relative;\n        &:hover{\n            .scroll-to-bottom-wrappers{\n                display: flex;\n            }\n        }\n        .scroll-to-bottom-wrappers{\n            z-index : 3;\n            position: absolute;\n            right: 10px;\n            display: none;\n            align-items: center;\n            justify-content: center;\n            width: 18px;\n            height: 18px;\n            border-radius: 50%;\n            border: 1px solid var(--Primary-200, #B2CCFF);\n            background: var(--Gray-600, #475467);\n            box-shadow: 0 4px 8px -2px rgba(16, 24, 40, 0.1019607843), 0 2px 4px -2px rgba(16, 24, 40, 0.0588235294);\n            transition: all 0.3s ease-in !important;\n            padding: 0;\n            top: 60px;\n            &:hover{\n                transform: scale(2) !important;\n            }\n            &.down-arrow{\n                bottom: 18px;\n                top: auto;\n            }\n        }\n        .assist-header-content{\n            display: flex;\n            align-items: center;\n            padding: 8px;\n            min-height: 36px;\n            gap: 10px;\n            border-bottom: 1px solid var(--AA-gloabl-border);\n            .left-title-info{\n                width: 100%;\n                // overflow: hidden;\n                .text-dropdown-info{\n                    display: flex;\n                    align-items: center;\n                    gap: 6px;\n                    h1{\n                        color: var(--AA-gloabl-text-color);\n                        font-size: 14px;\n                        font-weight: 600;\n                        line-height: 20px;\n                    }\n                    .interrupt-wrapper{\n                        display: flex;\n                        align-items: center;\n                        gap: 6px;\n                        flex-shrink: 0;\n                        .dialogs-number{\n                            border-radius: 4px;\n                            background: var(--AA-global-theme-bg);\n                            flex-shrink: 0;\n                            padding: 0px 4px;\n                            color: var(--AA-global-white-color);\n                            font-size: 12px;\n                            font-weight: 500;\n                            line-height: 18px;\n                            min-width: 16px;\n                            text-align: center;\n                        }\n                        .aa-dropdown {\n                            .aa-dropdown-toggle{\n                                padding: 0;\n                                border: 0;\n                                background: transparent;\n                                width: 16px;\n                                height: 16px;\n                                font-size: 16px;\n                                display: flex;\n                                align-items: center;\n                                justify-content: center;\n                            }\n                        }\n                    }\n                }\n                .bottom-titles{\n                    display: flex;\n                    align-items: center;\n                    gap: 6px;\n                    margin-top: 2px;\n                    p{\n                        color: var(--AA-gloabl-text-desc-color);\n                        max-width: 100%;\n                    }\n                    .entity-name-cstm{\n                        display: flex;\n                        align-items: center;\n                        padding-left: 6px;\n                        border-left: 1px solid var(--AA-gloabl-border);\n                        overflow: hidden;\n                        display: flex;\n                        align-items: center;\n                        gap: 2px;\n                    }\n                }\n            }\n            .actions-assist-header{\n                flex-shrink: 0;\n                display: flex;\n                align-items: center;\n                gap: 4px;\n                transition: 0.2s all ease;\n                .solid-action{\n                    border-radius: 3px;\n                    border: 0px solid var(--AA-gloabl-border);\n                    background: var(--AA-global-white-bg);\n                    display: flex;\n                    width: 25px;\n                    height: 25px;\n                    padding: 0;\n                    justify-content: center;\n                    align-items: center;\n                    gap: 6px;\n                    color: var(--AA-gloabl-text-color);\n                    font-size: 16px;\n                    cursor: pointer;\n                    svg{\n                        width: 14px;\n                        height: 14px;\n                        path{\n                            fill: var(--AA-gloabl-text-color);\n                        }\n                    }\n                    &:disabled{\n                        opacity: 0.3;\n                        pointer-events: none;\n                    }\n                    &:hover{\n                        border: 1px solid var(--AA-global-theme-bg);\n                        color: var(--AA-global-theme-text-color);\n                    }\n                    &.stop-assist{\n                        border: 0px solid var(--error-200, #FECDCA);\n                        background: var(--AA-global-white-bg);\n                        &:hover{\n                            border: 1px solid var(--error-300, #FDA29B);\n                            box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10);\n                        }\n                    }\n                    span{\n                        width: 12px;\n                        height: 12px;\n                        background: #D92D20;\n                    }\n                    sup{\n                        &.summary-indicator{\n                            position: absolute;\n                            background: var(--Error-500, #F04438);\n                            width: 2px;\n                            height: 2px;\n                            border-radius: 100%;\n                            right: 3px;\n                            top: 3px;\n                        }\n                    }\n                }\n                .sentiment-sec-wrapper{\n                    .sentiment-btn{\n                        padding: 2px 8px;\n                        font-size: 10px;\n                        font-weight: 400;\n                        line-height: 18px;\n                        border: 0;\n                        border-radius: 16px;\n                        &.negative-title{\n                            color: var(--Destructive-700, #B91C1C);\n                            background: var(--Destructive-50, #FEF2F2);\n                        }\n                        &.positive-title{\n                            color: #027a48;\n                            background: #ecfdf3;\n                        }\n                        &.neutral-title{\n                            background: #c9c1c1;\n                            color: #667085;\n                        }\n                    }\n                    .sentiment-chart-drp{\n                        width: 100%;\n                        left: 0;\n                        top: 42px;\n                        padding: 10px;\n                        border-radius: 8px;\n                        min-width: 200px;\n                        background: var(--AA-gloabl-bg-secondary);\n                        box-shadow: 0 2px 4px -2px #1018280f, 0 4px 8px -2px #1018281a;\n                        z-index: 6;\n                        max-width: 95%;\n                        right: 0;\n                        margin: 0 auto;\n\n                    }\n                }\n            }\n        }\n        .scroll-data-assist{\n            flex: 1 1 auto;\n            height: 100%;\n            overflow: auto;\n            .summery-conv-banner-wrapper{\n                padding: 12px;\n                border-radius: 8px;\n                border: 1px solid var(--AA-gloabl-border);\n                background: var(--AA-gloabl-bg-secondary);\n                margin: 8px;\n                .heading-text{\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    gap: 8px;\n                    margin-bottom: 10px;\n                    svg{\n                        flex-shrink: 0;\n                        path{\n                            fill: var(--AA-gloabl-text-color);\n                        }\n                    }\n                }\n                li{\n                    color: var(--AA-gloabl-text-color);\n                    font-size: 13px;\n                    font-weight: 400;\n                    line-height: 20px;\n                    list-style-type: none;\n                    display: flex;\n                    align-items: flex-end;\n                    gap: 8px;\n                    width: 100%;\n                    span{\n                        width: 100%;\n                    }\n                    .copy-btn{\n                        padding: 0;\n                        width: 25px;\n                        height: 25px;\n                        flex-shrink: 0;\n                        align-items: center;\n                        justify-content: center;\n                        font-size: 16px;\n                        border: 0;\n                        background: transparent;\n                        display: flex;\n                        cursor: pointer;\n                        border-radius: 4px;\n                        transition: 0.2s all ease;\n                        svg{\n                            path{\n                                stroke: var(--AA-gloabl-text-color);\n                            }\n                        }\n                        &:hover{\n                            background: var(--AA-global-white-bg);\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.empty-listing-triggers{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    flex-direction: column;\n    padding: 0 16px;\n}\n\n.app-dialog-assit-wrapper{\n    padding: 8px 10px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n.aa-dialog-ended-wrapper{\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 6px;\n    padding: 12px 0;\n    width: 100%;\n    .line_bar{\n        width: 100%;\n        border-top: 1px solid var(--AA-global-theme-bg);\n    }\n    .middle-info{\n        display: flex;\n        align-items: center;\n        flex-shrink: 0;\n        gap: 3px;\n        p{\n            font-size: 10px;\n            letter-spacing: 0.7px;\n        }\n        button{\n            font-size: 10px;\n            font-weight: 500;\n            line-height: normal;\n            letter-spacing: 0.7px;\n            max-width: 110px;\n        }\n    }\n}\n\n\n.custom-tab-data-wrapper-container{\n    padding: 8px;\n    .custom-tab-data-wrapper-container-content{\n        border: 1px solid var(--AA-gloabl-border);\n        border-radius: 4px;\n        .assist-block-content{\n            height: 100%;\n            display: flex;\n            flex-direction: column;\n            background: var(--AA-global-white-bg);\n            border-radius: 4px;\n            position: relative;\n            &:hover{\n                .scroll-to-bottom-wrappers{\n                    display: flex;\n                }\n            }\n            .scroll-to-bottom-wrappers{\n                z-index : 3;\n                position: absolute;\n                right: 10px;\n                display: none;\n                align-items: center;\n                justify-content: center;\n                width: 18px;\n                height: 18px;\n                border-radius: 50%;\n                border: 1px solid var(--Primary-200, #B2CCFF);\n                background: var(--Gray-600, #475467);\n                box-shadow: 0 4px 8px -2px rgba(16, 24, 40, 0.1019607843), 0 2px 4px -2px rgba(16, 24, 40, 0.0588235294);\n                transition: all 0.3s ease-in !important;\n                padding: 0;\n                top: 60px;\n                &:hover{\n                    transform: scale(2) !important;\n                }\n                &.down-arrow{\n                    bottom: 18px;\n                    top: auto;\n                }\n            }\n            .assist-header-content{\n                display: flex;\n                align-items: center;\n                padding: 8px;\n                min-height: 36px;\n                gap: 10px;\n                border-bottom: 1px solid var(--AA-gloabl-border);\n                .left-title-info{\n                    width: 100%;\n                    // overflow: hidden;\n                    .text-dropdown-info{\n                        display: flex;\n                        align-items: center;\n                        gap: 6px;\n                        h1{\n                            color: var(--AA-gloabl-text-color);\n                            font-size: 14px;\n                            font-weight: 600;\n                            line-height: 20px;\n                        }\n                        .interrupt-wrapper{\n                            display: flex;\n                            align-items: center;\n                            gap: 6px;\n                            flex-shrink: 0;\n                            .dialogs-number{\n                                border-radius: 4px;\n                                background: var(--AA-global-theme-bg);\n                                flex-shrink: 0;\n                                padding: 0px 4px;\n                                color: var(--AA-global-white-color);\n                                font-size: 12px;\n                                font-weight: 500;\n                                line-height: 18px;\n                                min-width: 16px;\n                                text-align: center;\n                            }\n                            .aa-dropdown {\n                                .aa-dropdown-toggle{\n                                    padding: 0;\n                                    border: 0;\n                                    background: transparent;\n                                    width: 16px;\n                                    height: 16px;\n                                    font-size: 16px;\n                                    display: flex;\n                                    align-items: center;\n                                    justify-content: center;\n                                }\n                            }\n                        }\n                    }\n                    .bottom-titles{\n                        display: flex;\n                        align-items: center;\n                        gap: 6px;\n                        margin-top: 2px;\n                        p{\n                            color: var(--AA-gloabl-text-desc-color);\n                            max-width: 100%;\n                        }\n                        .entity-name-cstm{\n                            display: flex;\n                            align-items: center;\n                            padding-left: 6px;\n                            border-left: 1px solid var(--AA-gloabl-border);\n                            overflow: hidden;\n                            display: flex;\n                            align-items: center;\n                            gap: 2px;\n                        }\n                    }\n                }\n                .actions-assist-header{\n                    flex-shrink: 0;\n                    display: flex;\n                    align-items: center;\n                    gap: 4px;\n                    transition: 0.2s all ease;\n                    .solid-action{\n                        border-radius: 3px;\n                        border: 0px solid var(--AA-gloabl-border);\n                        background: var(--AA-global-white-bg);\n                        display: flex;\n                        width: 25px;\n                        height: 25px;\n                        padding: 0;\n                        justify-content: center;\n                        align-items: center;\n                        gap: 6px;\n                        color: var(--AA-gloabl-text-color);\n                        font-size: 16px;\n                        cursor: pointer;\n                        svg{\n                            width: 14px;\n                            height: 14px;\n                            path{\n                                fill: var(--AA-gloabl-text-color);\n                            }\n                        }\n                        &:disabled{\n                            opacity: 0.3;\n                            pointer-events: none;\n                        }\n                        &:hover{\n                            border: 1px solid var(--AA-global-theme-bg);\n                            color: var(--AA-global-theme-text-color);\n                        }\n                        &.stop-assist{\n                            border: 0px solid var(--error-200, #FECDCA);\n                            background: var(--AA-global-white-bg);\n                            &:hover{\n                                border: 1px solid var(--error-300, #FDA29B);\n                                box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10);\n                            }\n                        }\n                        span{\n                            width: 12px;\n                            height: 12px;\n                            background: #D92D20;\n                        }\n                        sup{\n                            &.summary-indicator{\n                                position: absolute;\n                                background: var(--Error-500, #F04438);\n                                width: 2px;\n                                height: 2px;\n                                border-radius: 100%;\n                                right: 3px;\n                                top: 3px;\n                            }\n                        }\n                    }\n                    .pause-auto-send-btn{\n                        background: transparent;\n                        width: 25px;\n                        height: 25px;\n                        padding: 0;\n                        gap: 6px;\n                        cursor: pointer;\n                        svg{\n                            width: 14px;\n                            height: 14px;\n                            path{\n                                fill: var(--AA-global-theme-bg);\n                            }\n                        }\n                        &.paused-auto-send-btn{\n                            svg{\n                                path{\n                                    fill: var(--AA-global-white-bg);\n                                }\n                            }\n                        }\n                    }\n                    .sentiment-sec-wrapper{\n                        .sentiment-btn{\n                            padding: 2px 8px;\n                            font-size: 10px;\n                            font-weight: 400;\n                            line-height: 18px;\n                            border: 0;\n                            border-radius: 16px;\n                            &.negative-title{\n                                color: var(--Destructive-700, #B91C1C);\n                                background: var(--Destructive-50, #FEF2F2);\n                            }\n                            &.positive-title{\n                                color: #027a48;\n                                background: #ecfdf3;\n                            }\n                            &.neutral-title{\n                                background: #c9c1c1;\n                                color: #667085;\n                            }\n                        }\n                        .sentiment-chart-drp{\n                            width: 100%;\n                            left: 0;\n                            top: 42px;\n                            padding: 10px;\n                            border-radius: 8px;\n                            min-width: 200px;\n                            background: var(--AA-gloabl-bg-secondary);\n                            box-shadow: 0 2px 4px -2px #1018280f, 0 4px 8px -2px #1018281a;\n                            z-index: 6;\n                            max-width: 95%;\n                            right: 0;\n                            margin: 0 auto;\n    \n                        }\n                    }\n                }\n            }\n            .scroll-data-assist{\n                flex: 1 1 auto;\n                height: 100%;\n                overflow: auto;\n                .summery-conv-banner-wrapper{\n                    padding: 12px;\n                    border-radius: 8px;\n                    border: 1px solid var(--AA-gloabl-border);\n                    background: var(--AA-gloabl-bg-secondary);\n                    margin: 8px;\n                    .heading-text{\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        gap: 8px;\n                        margin-bottom: 10px;\n                        svg{\n                            flex-shrink: 0;\n                            path{\n                                fill: var(--AA-gloabl-text-color);\n                            }\n                        }\n                    }\n                    li{\n                        color: var(--AA-gloabl-text-color);\n                        font-size: 13px;\n                        font-weight: 400;\n                        line-height: 20px;\n                        list-style-type: none;\n                        display: flex;\n                        align-items: flex-end;\n                        gap: 8px;\n                        width: 100%;\n                        span{\n                            width: 100%;\n                        }\n                        .copy-btn{\n                            padding: 0;\n                            width: 25px;\n                            height: 25px;\n                            flex-shrink: 0;\n                            align-items: center;\n                            justify-content: center;\n                            font-size: 16px;\n                            border: 0;\n                            background: transparent;\n                            display: flex;\n                            cursor: pointer;\n                            border-radius: 4px;\n                            transition: 0.2s all ease;\n                            svg{\n                                path{\n                                    stroke: var(--AA-gloabl-text-color);\n                                }\n                            }\n                            &:hover{\n                                background: var(--AA-global-white-bg);\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .custom-tab-footer-section{\n            padding: 0 10px 10px 10px;\n            .custom-dialog-workflows-header{\n                .show-dialog-task-btn{\n                    cursor: pointer;\n                    background: transparent;\n                    color: var(--AA-global-theme-text-color);\n                    border: 0;\n                    padding: 0;\n                }\n                .line-divider{\n                    height: 1px;\n                    background: var(--AA-gloabl-border);\n                    width: 100%;\n                }\n            }\n            .custom-tab-dialog-card{\n                border-radius: 4px;\n                border: 1px solid var(--AA-gloabl-border);\n                background: var(--AA-global-white-bg);\n                padding: 6px 8px;\n                cursor: pointer;\n                svg{\n                    path{\n                        stroke: var(--AA-gloabl-text-desc-color);\n                    }\n                }\n            }\n        }\n    }\n}\n\n.ask-cust-node{\n    border-radius: 0px 10px 10px 10px;\n    background: var(--AA-gloabl-bg-secondary);\n    padding: 4px 8px;\n    margin-bottom: 6px;\n    .top-section{\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        min-height: 28px;\n        svg{\n            path{\n                fill: var(--AA-global-theme-text-color);\n            }\n        }\n        p{\n            margin: 0;\n        }\n    }\n    .msg-node-cust{\n        border-radius: 10px;\n        padding: 10px;\n        color: var(--AA-gloabl-text-color);\n        position: relative;\n        margin-top: 4px;\n        transition: 0.2s all ease;\n        z-index: 0;\n        &::before{\n            content: \"\";\n            background: var(--AA-global-theme-bg);\n            width: 100%;\n            height: 100%;\n            position: absolute;\n            z-index: -1;\n            left: 0;\n            top: 0;\n            border-radius: 10px;\n            opacity: 0.1;\n        }\n        &:hover{\n            .send-copy-actions{\n                display: flex;\n            }\n        }\n        p{\n            margin: 0;\n            padding-right: 28px;\n        }\n        .send-copy-actions{\n            border-radius: 4px;\n            background: var(--AA-global-white-bg);\n            box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10);\n            position: absolute;\n            display: none;\n            padding: 4px;\n            align-items: center;\n            gap: 6px;\n            right: 8px;\n            top: 4px;\n            z-index: 1;\n            svg{\n                path{\n                    stroke: var(--AA-gloabl-text-color);\n                }\n            }\n            .aa-solidbtn{\n                padding: 2px 11px;\n            }\n        }\n        .sent-msg-text{\n            position: absolute;\n            top: 0;\n            right: 4px;\n            color: var(--AA-global-theme-text-color);\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 20px;\n            height: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n    }\n\n}\n\n\n@-webkit-keyframes slideInLeftAnim {\n    0% {\n        -webkit-transform: translateX(-10px);\n        transform: translateX(-10px);\n        visibility: visible;\n    }\n\n    100% {\n        -webkit-transform: translateX(0);\n        transform: translateX(0);\n    }\n}\n\n@keyframes slideInLeftAnim {\n    0% {\n        -webkit-transform: translateX(-10px);\n        transform: translateX(-10px);\n        visibility: visible;\n    }\n\n    100% {\n        -webkit-transform: translateX(0);\n        transform: translateX(0);\n    }\n}\n\n.entity-mesage-data{\n    padding: 8px;\n    margin-bottom: 6px;\n    &.listView{\n        padding: 0px !important;\n    }\n    &.error-no-reponse{\n        .input-block-entity {\n            textarea,input {\n                &:focus{\n                    + .border-outline{\n                        border: 1px solid var(--destructive-300, #FCA5A5);\n                        box-shadow: 0px 0px 0px 4px #FEE4E2, 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n                    }\n                }\n                + .border-outline{\n                    border: 1px solid var(--destructive-300, #FCA5A5);\n                }\n            }\n        }\n        .info-entity-text{\n            opacity: 1;\n            color: var(--destructive-500-main, #EF4444);\n        }\n    }\n    .input-block-entity{\n        position: relative;\n        display: flex;\n        align-items: center;\n        gap: 5px;\n        padding: 0px 12px;\n        z-index: 2;\n        min-height: 40px;\n        p{\n            color: var(--AA-gloabl-text-desc-color);\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 18px;\n            margin: 0;\n            flex-shrink: 0;\n            position: relative;\n            z-index: 2;\n            max-width: 85%;\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n        }\n        textarea[readonly],input[readonly]{\n            opacity: 0.7;\n        }\n        textarea,input{\n            width: 100%;\n            border: 0;\n            outline: 0;\n            position: relative;\n            z-index: 2;\n            padding: 0;\n            color: var(--AA-gloabl-text-desc-color);\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 18px;\n            // min-height: 36px;\n            resize: none;\n            background: transparent;\n            overflow: auto;\n            &:focus{\n                + .border-outline{\n                    border-radius: 8px;\n                    border: 1px solid var(--AA-global-theme-bg);\n                    box-shadow: 0px 0px 0px 4px #E1E1FE;\n                }\n            }\n            + .border-outline{\n                position: absolute;\n                border-radius: 8px;\n                border: 1px solid var(--AA-global-theme-bg);\n                box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n                width: 100%;\n                height: 100%;\n                left: 0;\n                top: 0;\n            }\n            &.disable-input{\n                opacity: 0.7;\n            }\n            &.attachment-input{\n                position: absolute;\n                left: 0;\n                opacity: 0;\n                font-size: 0px;\n                cursor: pointer;\n                &.uploaded-img-attach{\n                    visibility: hidden;\n                    display: none;\n                }\n            }\n        }\n        svg{\n            flex-shrink: 0;\n            position: relative;\n            z-index: 1;\n            cursor: pointer;\n        }\n        .attach-input{\n            display: flex;\n            align-items: center;\n            gap: 5px;\n            overflow: hidden;\n            width: 100%;\n            svg{\n                path{\n                    stroke: var(--AA-global-theme-bg);\n                }\n            }\n        }\n        .attachment-name{\n            color: var(--AA-gloabl-text-desc-color);\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 16px;\n            width: 100%;\n            &.choose-file{\n                color: var(--AA-global-theme-text-color); \n            }\n        }\n        .actions-inputs{\n            display: flex;\n            align-items: center;\n            position: relative;\n            z-index: 2;\n            gap: 4px;\n            flex-shrink: 0;\n            -webkit-animation-name: slideInLeftAnim;\n            animation-name: slideInLeftAnim;\n            -webkit-animation-duration: 1s;\n            animation-duration: 1s;\n            -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n            .remove-input{\n                width: 24px;\n                height: 24px;\n                padding: 0;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                background: transparent;\n                border: 0;\n                font-size: 20px;\n                color: var(--AA-gloabl-text-desc-color);\n            }\n            .check-input{\n                @extend .remove-input;\n                font-size: 12px;\n                color: var(--AA-global-theme-text-color);\n            }\n            .success-check-input{\n                @extend .remove-input;\n                color: #12B76A;\n            }\n            .wrong-res-info{\n                display: flex;\n                padding: 0px 10px;\n                justify-content: center;\n                align-items: center;\n                gap: 6px;\n                border-radius: 24px;\n                border: 1px solid var(--destructive-600, #DC2626);\n                background: var(--destructive-50, #FEF2F2);\n                color: var(--destructive-600, #DC2626);\n                font-size: 12px;\n                font-weight: 500;\n                min-height: 22px;\n                i{\n                    font-size: 16px;\n                }\n            }\n            .override-btn{\n                background: transparent;\n                padding: 0;\n                border: 0;\n                font-size: 12px;\n                font-weight: 400;\n                line-height: 20px;\n                cursor: pointer;\n                color: var(--AA-global-theme-text-color);\n            }\n        }\n    }\n    .info-entity-text{\n        color: var(--AA-gloabl-text-desc-color);\n        opacity: 0.7;\n        font-size: 10px;\n        font-weight: 500;\n        line-height: normal;\n        margin: 3px 0 0 0;\n    }\n}\n\n.expand-btn{\n    background-color: transparent;\n    border: none;\n}\n\n.reduce-btn{\n    background-color: transparent;\n    border: none;\n}\n\n.form-feedback-info{\n    background: var(--AA-gloabl-bg-secondary);\n    padding: 8px;\n    .dialog-ended-and-feedback{\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        .line-border-content-info{\n            width: 100%;\n            top: 0;\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            .line-border{\n                background: var(--AA-global-theme-text-color);\n                width: 100%;\n                height: 1px;\n            }\n            .date-time-text{\n                flex-shrink: 0;\n                border-radius: 16px;\n                background: var(--AA-gloabl-bg-secondary);\n                padding: 2px 8px;\n                color: var(--AA-global-theme-text-color);\n                font-size: 12px;\n                font-weight: 400;\n                line-height: 18px;\n            }\n        }\n        .feedback-wrapper{\n            .feedback-actions-info{\n                display: flex;\n                align-items: center;\n                gap: 6px;\n                .left-sec-info{\n                    display: flex;\n                    align-items: center;\n                    gap: 6px;\n                    width: 100%;\n                    .icon_block{\n                        flex-shrink: 0;\n                        width: 24px;\n                        height: 24px;\n                    }\n                    h1{\n                        color: var(--AA-gloabl-text-color);\n                        font-size: 12px;\n                        font-weight: 500;\n                        line-height: 18px;\n                        margin: 0;\n                    }\n                    .feedback-btn-thumb{\n                        border-radius: 4px;\n                        border: 1px solid var(--AA-gloabl-border);\n                        background: var(--AA-global-white-bg);\n                        display: flex;\n                        width: 20px;\n                        height: 20px;\n                        padding: 0;\n                        justify-content: center;\n                        align-items: center;\n                        gap: 6px;\n                        color: var(--AA-gloabl-text-color);\n                        font-size: 12px;\n                        cursor: pointer;\n                        transition: 0.2s all ease;\n                        svg{\n                            path{\n                                stroke: var(--AA-gloabl-text-color);\n                            }\n                        }\n                        &:disabled{\n                            opacity: 0.3;\n                        }\n                        &.active-feedback-btn{\n                            background: var(--AA-global-theme-bg);\n                            color: var(--AA-global-white-color);\n                            svg{\n                                path{\n                                    stroke: var(--AA-global-white-color);\n                                }\n                            }\n                        }\n                        &:hover{\n                            background: var(--AA-global-theme-bg);\n                            color: var(--AA-global-white-color);\n                            svg{\n                                path{\n                                    stroke: var(--AA-global-white-color);\n                                }\n                            }\n                        }\n                    }\n                    .feedback-btn-arrow{\n                        border: 0;\n                        padding: 0;\n                        background: transparent;\n                        width: 20px;\n                        height: 20px;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        font-size: 20px;\n                        transform: rotate(0);\n                        opacity: 0.7;\n                        svg{\n                            path{\n                                fill: var(--AA-gloabl-text-color);\n                            }\n                        }\n                        &.active-feedback-btn-rotate{\n                            transform: rotate(180deg);\n                        }\n                    }\n                }\n                .thankyou-text{\n                    flex-shrink: 0;\n                    color: var(--AA-global-theme-bg);\n                    font-size: 12px;\n                    font-weight: 400;\n                    line-height: 20px;\n                    margin: 0;\n                    padding-right: 8px;\n                }\n            }\n        }\n        .form-feedback-div{\n            flex-shrink: 0;\n        }\n    }\n    \n    \n    .improve-feedback-block{\n        padding: 12px;\n        border-radius: 10px;\n        position: relative;\n        z-index: 0;\n        margin-top: 4px;\n        &::before{\n            content: \"\";\n            background: var(--AA-global-theme-bg);\n            width: 100%;\n            height: 100%;\n            position: absolute;\n            z-index: -1;\n            left: 0;\n            top: 0;\n            border-radius: 10px;\n            opacity: 0.2;\n        }\n        .improve-options-text{\n            display: flex;\n            flex-wrap: wrap;\n            gap: 4px;\n            margin-bottom: 12px;\n            .improve-lable-text{\n                border-radius: 16px;\n                background: var(--AA-gloabl-bg-secondary);\n                display: flex;\n                padding: 2px 8px;\n                justify-content: center;\n                align-items: center;\n                color: var(--AA-gloabl-text-color);\n                font-size: 12px;\n                font-weight: 500;\n                line-height: 18px;\n                border: 0;\n                min-height: 22px;\n                transition: 0.2s all ease;\n                // mix-blend-mode: multiply;\n                &:hover{\n                    background: var(--AA-global-theme-bg);\n                    color: var(--AA-global-white-color);\n                }\n                &.active-improve-btn{\n                    background: var(--AA-global-theme-bg);\n                    color: var(--AA-global-white-color);\n                }\n            }\n        }\n        .input-improve-text{\n            display: flex;\n            align-items: center;\n            textarea{\n                font-size: 12px;\n                font-weight: 400;\n                line-height: 18px;\n                resize: none;\n            }\n        }\n        .submit-count-text{\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            margin-top: 4px;\n            justify-content: flex-end;\n            p{\n                width: 100%;\n                color: var(--AA-gloabl-text-color);\n                font-size: 12px;\n                font-weight: 400;\n                line-height: 20px;\n                margin: 0;\n            }\n        }\n        .send-btn-feedback{\n            flex-shrink: 0;\n            height: 25px;\n            border-radius: 8px;\n            border: 1px solid var(--AA-global-theme-bg);\n            background: var(--AA-global-theme-bg);\n            box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n            color: var(--AA-global-white-color);\n            font-size: 12px;\n            font-weight: 500;\n            line-height: 20px;\n            &:disabled{\n                opacity: 0.3;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
